import { Local } from "@/utils/storage";
import { findNodePath, findNode } from "@/utils/getTreeNodes.js";
import { handleUserMenuAuth } from '@/utils/auth';

export default ({
  name: 'SingleronPcMenus',
  components: {
  },
  data() {
    return {
      userName: 'My analyses',
      menusList: [],
      acountList: [],
    };
  },
  props: {
  },
  watch: {
    $route() {
      this.refreshRoute();
    },
  },
  computed: {
    activePath() {
      return this.$store.state.routesList.activePath;
    },
  },
  mounted() {
    this.initData();
  },
  methods: {
    // 处理菜单权限
    handleAuth() {
      const userInfo = Local.get('user_info');
      if (!userInfo) { return; }
      const menu = userInfo.privileges;
      handleUserMenuAuth(menu);
      this.userName = Local.get('username');
      this.menusList = this.$store.state.routesList.routesList;
      this.acountList = this.menusList[this.menusList.length - 1].children;
      this.$emit('sendAcountList', this.acountList);
      
      this.menusList = this.menusList.filter(item => item.name !== 'My account');
      this.menusList.forEach(item => {
        if(item.id === 'CeleLens:IntergrateData') {
          item.children.unshift({
            id: 'SingleCellRNA-SeqTitle',
            label: 'Single Cell RNA-Seq',
            disabled: true,
            name: "Single Cell RNA-Seq",
          });
            item.children.splice(4, 0, {
              id: 'SpatialTranscriptomicsTitle',
              label: 'Spatial Transcriptomics',
              disabled: true,
              name: "Spatial Transcriptomics",
            });
            item.children.splice(6, 0, {
              id: 'BulkRNA-SeqTitle',
              label: 'Bulk RNA-Seq',
              disabled: true,
              name: "Bulk RNA-Seq",
            });
        }
      });
    },

    initData() {
      this.handleAuth();
      this.refreshRoute();
    },

    refreshRoute() {
      const activePath = this.$store.state.routesList.activePath;
      if (!activePath) {
        return;
      }
      this.handleRefreshRouteSwitch(activePath);
    },

    handleRefreshRouteSwitch(activePath) {
      this.findFatherNode('routePath', activePath);
    },

    handleCommand(val) {
      this.handleRoute('id', val);
      this.findFatherNode('id', val);
    },

    // 处理路由跳转
    handleRoute(key, val) {
      const targetNode = findNode(key, this.menusList, val);
      if (targetNode && targetNode.disabled) {
        return;
      }
      if (targetNode && targetNode.routePath) {
        this.$router.push({
          path: targetNode.routePath,
          query: targetNode.query? targetNode.query : {}});
          this.$emit('sendRoute');
      }
    },

    // 查询当前节点的顶级父节点
    findFatherNode(key, val) {
      let formatVal = val;
      let formatKey = key;
      if (val === '/') {
        formatVal = 'Homepage';
        formatKey = 'id';
      }
      const nodeArray = findNodePath(formatKey, this.menusList, formatVal);

      if (!nodeArray.length) {
        return;
      }
      const firstNode = nodeArray[0];
      this.menusList.forEach(item => item.active = false);
      this.menusList.find(item => item.id === firstNode.id).active = true;
    },

  },
});